(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header');
      if (!this.header) return;
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.scrollFrame = null;
      this.needsMeasurement = true;
      this.headerOrigin = document.createElement('span');
      this.headerOrigin.setAttribute('aria-hidden', 'true');
      this.headerOrigin.style.cssText = 'display:block;width:0;height:0;margin:0;padding:0;border:0;flex:none;';
      this.header.before(this.headerOrigin);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = () => this.scheduleUpdate();
      this.onResizeHandler = () => {
        this.needsMeasurement = true;
        this.scheduleUpdate();
      };
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler, { passive: true });
      document.fonts?.addEventListener('loadingdone', this.onResizeHandler);

      this.resizeObserver = new ResizeObserver(this.onResizeHandler);
      this.resizeObserver.observe(this.header);
      for (let sibling = this.headerOrigin.previousElementSibling; sibling; sibling = sibling.previousElementSibling) {
        if (sibling.classList.contains('shopify-section-group-header-group')) {
          this.resizeObserver.observe(sibling);
        }
      }
      this.scheduleUpdate();
    }

    setHeaderHeight() {
      const height = this.header.getBoundingClientRect().height;
      const top = this.headerOrigin.getBoundingClientRect().top + window.scrollY;
      this.headerBounds = { top, bottom: top + height };
      const value = `${height}px`;
      if (document.documentElement.style.getPropertyValue('--header-height') !== value) {
        document.documentElement.style.setProperty('--header-height', value);
      }
      if (window.scrollY <= this.headerBounds.bottom) {
        this.header.classList.remove('scrolled-past-header');
        this.reset();
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      document.fonts?.removeEventListener('loadingdone', this.onResizeHandler);
      this.resizeObserver?.disconnect();
      if (this.scrollFrame !== null) cancelAnimationFrame(this.scrollFrame);
      window.clearTimeout(this.isScrolling);
      this.headerOrigin?.remove();
      this.scrollFrame = null;
      this.header = null;
      this.headerOrigin = null;
      this.disclosures = null;
      this.searchModal = null;
    }

    scheduleUpdate() {
      if (this.scrollFrame !== null || !this.isConnected || !this.header) return;
      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = null;
        if (!this.isConnected || !this.header) return;
        if (this.needsMeasurement) {
          this.needsMeasurement = false;
          this.setHeaderHeight();
        }
        this.onScroll();
      });
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        this.hide();
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          this.reveal();
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          this.hide();
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.reset();
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
